import { FormGroup } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import IntakeCard from 'candidate/components/IntakeCard'
import { ChoiceBucket } from 'candidate/models/intake'
import React, { useEffect, useState } from 'react'
import NextButton from 'shared/components/NextButton'
import { getPxAsRem } from 'shared/utils'
import { toMonthDate } from 'shared/utils/dateFormatter'

interface Props {
    answer?: string
    callback: React.Dispatch<React.SetStateAction<Record<string, ChoiceBucket>>>
    prompt: string
    subtext?: string
    skipCallback?: React.Dispatch<React.SetStateAction<string>>
    skipText?: string
    label?: string
    repeat?: number
}

const DatePickerQuestion: React.FC<Props> = ({
    answer,
    callback,
    prompt,
    subtext,
    skipCallback,
    skipText,
    label,
    repeat = 1,
}: Props) => {
    const [disabled, setDisabled] = useState(true)
    const [response, setResponse] = useState<string>(answer || '')

    useEffect(() => {
        setDisabled(answer ? false : true)
        setResponse(answer || '')
    }, [answer, prompt])

    const handleSetResponse = (value: string): void => {
        setResponse(value)
        if (value.length !== 0) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }

    return (
        <>
            <IntakeCard
                question={prompt}
                subtext={subtext}
                skipCallback={skipCallback}
                skipText={skipText}
            >
                {Array.from({ length: repeat }, (_, index) => (
                    <FormGroup
                        key={index}
                        style={{
                            display: 'inline-block',
                            alignContent: 'left',
                            marginBottom: getPxAsRem(36),
                            marginTop: getPxAsRem(16),
                            padding: '0',
                            width: '100%',
                            maxWidth: getPxAsRem(500),
                        }}
                    >
                        <DatePicker
                            format="MM/yyyy"
                            value={toMonthDate(response, 'dateobject')}
                            onChange={(value: Date | null) => {
                                handleSetResponse(toMonthDate(value, 'MM-yyyy'))
                            }}
                            label={label}
                            views={['year', 'month']}
                        />
                    </FormGroup>
                ))}
                <NextButton
                    disabled={disabled}
                    onClickHandler={() => {
                        const choiceBucket: ChoiceBucket = {
                            choice: response,
                        }
                        setDisabled(true)
                        callback({ response: choiceBucket })
                    }}
                />
            </IntakeCard>
        </>
    )
}

export default DatePickerQuestion
